// EDIT WITH PUS
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

// material ui components
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
//icons
import SaveIcon from '@material-ui/icons/Save';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import Slide from '@material-ui/core/Slide';

import { usePouchDB } from '../../../../components/PouchDB/PouchDBProvider';
import { Swipeable } from 'react-swipeable';
//styles
import useStyles from '../styles/pus';
import { useSnackbar } from 'notistack';

//date utils
import parseDate from 'date-fns/parse';
import differenceInCalendarDays from 'date-fns/differenceInCalendarDays';

import { countAge } from '../pk/validation';

import Form from './form'
import { sub } from 'pouchdb-find';

export const formatString = "dd-MM-yyyy";

function PusLainnya({ wilayah, id, keluarga, kb, mainSlide, pusLainnya, setPusLainnya, handleNext, handleBack, handleDraft, handleSegmen, handleAnomali, mode, pertanyaanPus, jmlHamilLainnya, hamilPertamaLainnya }) {

    const classes = useStyles();

    const { enqueueSnackbar } = useSnackbar();
    const [error, setError] = useState({})

    const { user: { metadata }, dataKK, dataPK, dataKB, dataBkkbn } = usePouchDB();
    const [isSomethingChange, setSomethingChange] = useState(false);
    const [isSubmitting, setSubmitting] = useState(false);
    const [isSaved, setSaved] = useState({
        local: false,
        remote: false
    })

    const [form, setForm] = useState([])

    let valIndex = 0
    //action draft
    if (wilayah.status_draft === 1 && wilayah.pos_draft === 4 && wilayah.subformIndex !== undefined) {
        valIndex = String(wilayah.subformIndex) === "null" ? 0 : wilayah.subformIndex
    }
    const [subformIndex, setSubFormIndex] = useState(valIndex);

    const [navigationMode, setNavigationMode] = useState('next');
    const [slide, setSlide] = useState({
        direction: "left",
        in: true
    });

    useEffect(() => {

        if (pertanyaanPus !== "1") {
            if (mainSlide.navigationMode === "next") {
                handleNext();
            } else {
                handleBack()
            }
        } else {

            if (hamilPertamaLainnya === "1") {

                const jumlah_keluarga = parseInt(jmlHamilLainnya);
                setPusLainnya(cPusLainnya => {
                    let newKeluarga = {}
                    for (let i = 0; i < jumlah_keluarga; i++) {

                        const currKeluarga = cPusLainnya[i] || {}
                        newKeluarga[i] = {
                            ...currKeluarga
                        }

                    }

                    setForm([
                        ...Object.keys(newKeluarga).map(key => ({ id: key })),
                    ])

                    return newKeluarga
                })

            } else {
                setPusLainnya([])
                if (mainSlide.navigationMode === "next") {
                    handleNext();
                } else {
                    handleBack()
                }
            }
        }

    }, [])

    const f = form[subformIndex]
    const pusValue = pusLainnya[subformIndex]

    function countAgeMonth(tgl_lahir) {
        const days = differenceInCalendarDays(new Date(), parseDate(tgl_lahir, formatString, new Date()));

        const month = days / 30.41;
        return parseInt(month);
    }

    const ageConvert = (tgl_lahir) => {
        const month = countAgeMonth(tgl_lahir);//days / 365;
        let umur = month / 12

        // if (month > 720)
        return umur;
    }

    const handleCheckSegmen = async (event) => {
        const findErrors = validate();

        const errorValues = Object.values(findErrors);

        if (errorValues.length > 0 && errorValues.some(err => err !== '')) {
            setError(findErrors);
        } else {
            if (subformIndex === 0) {
                enqueueSnackbar("Silahkan Klik Selanjutnya", { variant: 'warning' })
            } else {

                const { value } = event.target;
                // console.log(wilayah.status_draft, "status_draft")
                // const x = Object.keys(keluarga).length;
                const x = parseInt(wilayah.jumlah_keluarga);
                // console.log(x, 'jml kel')
                if (value) {
                    let val = parseInt(value);
                    // console.log(val, 'val parseint')
                    if (x > 1) {
                        (val > 1) ? val = val + x - 1 : val = val
                    }

                    let segment_pus = wilayah.pertanyaan_pus || ''
                    if ((x === 1 && val === 2) || (segment_pus !== 1 && value === 4)) {
                        console.log("masuk if kb")
                        let message
                        if (val === 2) {
                            message = `Data KB tidak Tersedia`
                        } else {
                            message = `Data Stunting tidak Tersedia`
                        }

                        enqueueSnackbar(message, { variant: "warning" })
                    } else {
                        // console.log("masuk jmlklg" + x + "val" + val)
                        handleSegmen(event, val)
                    }
                }
            }

        }

    }

    const validate = () => {
        let newError = {};

        return newError;

    }

    const handleNextSub = () => {

        if (subformIndex >= form.length - 1) {
            console.log("run")
            return handleNext()
        }
        setNavigationMode('next')
        setSlide({
            direction: "right",
            in: false
        });
        setTimeout(() => {

            setSubFormIndex(index => index + 1);
            setSlide({
                direction: "left",
                in: true
            })

        }, 300)

    }

    const handleBackSub = () => {

        if (subformIndex === 0) {
            return handleBack()
        }

        setNavigationMode('back')
        setSlide({
            direction: "left",
            in: false
        });
        setTimeout(() => {

            setSubFormIndex(index => index - 1);
            setSlide({
                direction: "right",
                in: true
            })

        }, 300)
    }

    const setValue = (e) => {

        let name = e.target.name
        let value = e.target.value
        setPusLainnya((pusLainnya) => ({
            ...pusLainnya,
            [f.id]: {
                ...pusLainnya[f.id],
                [name]: value
            }
        }))
    }

    console.log("data pus lainnya => ", pusLainnya)

    return (
        <Swipeable>
            <Grid container spacing={3}>

                <Grid item xs={12} className={classes.textCenter}>
                    <Typography variant="h5" component="h1">{mode === 'edit' ? `Edit Form Stunting` : 'Form Stunting'}</Typography>
                    {/* {mode === 'edit' && <Typography>No KK: {no_kk}</Typography>} */}
                </Grid>

                <Grid item xs className={classes.textLeft}>
                    {
                        mode === "edit" && wilayah.status_draft && wilayah.status_draft === '1' ?
                            <> <Button
                                color="primary"
                                variant="contained"
                                onClick={handleDraft('local', 7, subformIndex)}
                                disabled={isSubmitting.local || isSaved.local}
                            >
                                <SaveIcon className={classes.iconLeft} /> Save as Draft </Button> </> : <></>
                    }

                    {
                        mode === "edit" && (wilayah.status_draft === undefined || wilayah.status_draft === '2') ?
                            <>
                                <FormControl
                                    variant="outlined">
                                    <Select
                                        id=""
                                        value=""
                                        name="segmen"
                                        onChange={handleCheckSegmen}
                                        displayEmpty
                                    >
                                        <MenuItem value=""> Segmen </MenuItem>
                                        <MenuItem value="0"> Wilayah </MenuItem>
                                        <MenuItem value="1"> Keluarga </MenuItem>
                                        <MenuItem value="2"> KB </MenuItem>
                                        <MenuItem value="3"> PK </MenuItem>
                                        {/* <MenuItem value="4"> Stunting </MenuItem> */}
                                    </Select>
                                </FormControl>
                            </> : <></>
                    }

                    {
                        mode !== "edit" ?
                            <> <Button
                                color="primary"
                                variant="contained"
                                onClick={handleDraft('local', 7, subformIndex)}
                                disabled={isSubmitting.local || isSaved.local}
                            >
                                <SaveIcon className={classes.iconLeft} /> Save as Draft </Button> </> : <></>
                    }
                </Grid>

                <Grid item>
                    {
                        mode === "edit" && wilayah.status_sensus === 'Anomali' ?
                            <> <Button
                                color="primary"
                                variant="contained"
                                onClick={handleAnomali('local', 1)}
                                disabled={isSubmitting.local || isSaved.local}
                            >
                                <AssignmentTurnedInIcon /> Anomali Terkonfirmasi </Button> </> : <></>
                    }
                </Grid>

                <Grid item xs={12}>
                    <Divider />
                </Grid>

                <Grid item xs={12}>
                    <Slide direction={slide.direction} in={slide.in}>
                        <div className={classes.slideContent}>
                            {f && <Form
                                id={f.id}
                                setValue={setValue}
                                pusLainnya={pusLainnya}
                                setPusLainnya={setPusLainnya}
                                keluarga={keluarga}
                                pusValue={pusValue}
                                ageConvert={ageConvert}
                                subformIndex={subformIndex}
                                handleNextSub={handleNextSub}
                                handleBackSub={handleBackSub}
                                navigationMode={navigationMode}
                                isSubmitting={isSubmitting}
                            />}
                        </div>
                    </Slide>
                </Grid>

            </Grid>
        </Swipeable>
    )
}

export default PusLainnya;